<template>
  <span class="amount" v-if="isValid">
    &euro; {{ formattedAmount }}
  </span>
</template>

<script type="text/javascript">
export default {
  name: "AmountComponent",
  props: {
    value: {
      type: [Number, String],
      required: false,
    },
    decimalPlaces: {
      type: [Number, String],
      default: 2,
    },
    decimalSeparator: {
      type: String,
      default: ',',
    },
    thousandsSeparator: {
      type: String,
      default: '.',
    }
  },
  data() {
    return {
      stateValue: this.value,
    };
  },
  computed: {
    isValid() {
      return typeof this.value !== "undefined"
    },
    formattedAmount() {
      let amount = parseFloat(this.value);
      let formattedAmount = amount.toFixed(this.formattedDecimalPlaces) + '';
      let splitNumber = formattedAmount.split('.');
      let beforeDecimal = splitNumber[0];
      let afterDecimal = splitNumber.length > 1 ? this.decimalSeparator + splitNumber[1] : '';

      let regex = /(\d+)(\d{3})/;

      while (regex.test(beforeDecimal)) {
        beforeDecimal = beforeDecimal.replace(regex, '$1' + this.thousandsSeparator + '$2');
      }
      return beforeDecimal + afterDecimal;
    },
    formattedDecimalPlaces() {
      return parseInt(this.decimalPlaces);
    }
  }
}
</script>

<style scoped>
</style>
